import { useView } from '../app/use-view.ts'
import styles from './crosshair.module.css'

/** A dot at the center that opens into a ring on something usable. Hidden while holding. */
export function Crosshair() {
  const focused = useView((view) => view.hud.targetFocused)
  const holding = useView((view) => view.hud.holding)
  if (holding) return null
  return <div class={styles.crosshair} data-focused={focused || undefined} aria-hidden="true" />
}
